module.exports = __webpack_public_path__ + "static/media/ico-card.6b658db6.svg";